var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('GmapMap',{ref:"map",staticStyle:{"width":"100%","height":"900px"},attrs:{"center":_vm.mapPos,"zoom":12,"options":{
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: true,
        streetViewControl: false,
        rotateControl: true,
        fullscreenControl: true,
        disableDefaultUi: false
      }}},_vm._l((_vm.items),function(mapItem,index){return _c('GmapPolygon',{key:index,attrs:{"paths":mapItem.paths,"options":{
        strokeColor: mapItem.strokeColour,
        fillColor: mapItem.strokeColour,
      }},on:{"click":function($event){return _vm.polygonClick(mapItem)}}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }